import {ResearchLitElement, html, css} from '@core/research-lit-element';

class researchSection extends ResearchLitElement {
    static get is() {
        return 'research-section';
    }

    static get styles() {
        return css`
            :host {
                display: flex;
                align-self: stretch;
                justify-content: center;
                padding: var(--section-space) var(--border-space);
                --section-background-color: var(--color-invert-background-solid-10);
                background-color: var(--section-background-color);
                position: relative;
            }

            :host([show-on-responsive]) {
                display: none;
            }

            :host([wide]) {
                --content-max-width: 1296px;
            }

            .overlay {
                display: none;
            }

            :host([grey]) {
                --section-background-color: var(--color-greyish-seventh);
            }

            :host([dark]) {
                background-image: linear-gradient(to right, #262d37, #454c56);
            }

            :host([dark-blue]) .overlay {
                position: absolute;
                display: block;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                opacity: 1;
                background: #04253d;
            }

            :host([dark-blue]) .container {
                position: relative;
            }

            :host([background-image]) {
                background-image: var(--section-background-image);
            }

            :host([no-pad-bottom]) {
                padding-bottom: 0px;
            }

            :host([no-pad-top]) {
                padding-top: 0px;
            }
            :host([contacts]) {
                margin-bottom: var(--section-space);
            }

            :host([center]) .container {
                display: flex;
                flex-grow: 1;
                justify-content: center;
            }

            .container {
                flex: 1;
                width: 100%;
                max-width: var(--content-max-width);
            }

            @media (max-width: 1200px) {
                :host([show-on-responsive]) {
                    display: flex;
                }
            }

            @media (max-width: 760px) {
                :host([hide-compare-on-responsive]) {
                    display: none;
                }

                .container {
                    max-width: 100%;
                }
            }
        `;
    }

    render() {
        return html`
            <div class="overlay"></div>
            <div class="container">
                <slot></slot>
            </div>
        `;
    }

    constructor() {
        super();
        this.showOnResponsive = false;
    }

    static get properties() {
        return {
            backgroundImage: {
                type: String,
                reflect: true,
            },
            showOnResponsive: {
                type: Boolean,
                reflect: true,
            },
            wide: Boolean,
        };
    }
}

window.customElements.define(researchSection.is, researchSection);
